import type {
    AnyConnectionType,
    AnyEdgeType,
    NodeForEdge,
    PageInfoForConnection,
    EdgeForConnection,
    NodeForConnection,
} from './../derived/output';

/**
 * Checks wheter the provided object has a `totalCount` property that is a number.
 */
export function hasTotalCount(obj: unknown): obj is { totalCount: number } {
    return (
        typeof obj === 'object' &&
        !!obj &&
        'totalCount' in obj &&
        typeof obj.totalCount === 'number'
    );
}

export function connectionHasPageInfo<C extends AnyConnectionType>(
    connection: C | null | undefined
): connection is C & { pageInfo: PageInfoForConnection<C> } {
    return (
        typeof connection === 'object' &&
        !!connection &&
        'pageInfo' in connection &&
        !!connection.pageInfo
    );
}

export function connectionHasEdges<C extends AnyConnectionType>(
    connection: C | null | undefined
): connection is C & { edges: EdgeForConnection<C>[] } {
    return (
        typeof connection === 'object' &&
        !!connection &&
        'edges' in connection &&
        Array.isArray(connection.edges)
    );
}

export function connectionHasNodes<C extends AnyConnectionType>(
    connection: C | null | undefined
): connection is C & { nodes: NodeForConnection<C>[] } {
    return (
        typeof connection === 'object' &&
        !!connection &&
        'nodes' in connection &&
        Array.isArray(connection.nodes)
    );
}

export function edgeHasNode<E extends AnyEdgeType>(
    edge: E | null | undefined
): edge is E & { node: NodeForEdge<E> } {
    return typeof edge === 'object' && !!edge && 'node' in edge && !!edge.node;
}
